import React from 'react'
import { Check } from 'lucide-react'
import { cn } from '../../../../utils/classnames'

const ProfileTab = ({ label, active, completed, onClick }) => {
  return (
    <button
        onClick={onClick}
        className={cn(
            'flex-1 w-full flex flex-col items-center px-4 py-4 text-center rounded-custom20 border text-base font-semibold transition-all',
            active
            ? 'bg-tealLight text-white'
            : 'bg-white text-blueDarker border-blueLight hover:bg-blueSoft'
        )}
    >
      <div
        className={cn(
          'w-9 h-9 mb-3 rounded-full flex items-center justify-center border transition-all',
          completed
            ? 'border-tealBase'
            : 'border-bluePale',
          active && 'bg-blueExtraLight'
        )}
      >
        {completed && (
          <Check
            size={20}
            className={cn(
              active ? 'text-tealBase' : 'text-tealBase',
            )}
            strokeWidth={2.5}
          />
        )}
      </div>

      <span>{label}</span>
    </button>
  )
}

export default ProfileTab
